import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Coaching from './pages/Coaching';
import Workshops from './pages/Workshops';
import ParentingStrategies from './pages/ParentingStrategies';
import Affirmations from './pages/Affirmations';
import LiesPriceAdvice from './pages/LiesPriceAdvice';
import SelfCare from './pages/SelfCare';
import Workbook from './pages/Workbook';
import Admin from './pages/Admin';
import { AdminProvider } from './lib/AdminContext';
import { EditorProvider, useRegisterEditor } from './lib/EditorContext';
import { supabase } from './lib/supabaseClient';
import { defaultContent } from './lib/defaultContent';
import OnSiteEditor from './components/OnSiteEditor';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function GlobalEditorRegister({ content, onSave }) {
  useRegisterEditor('global', content, onSave, 'Global Settings');
  return null;
}

function App() {
  const [globalContent, setGlobalContent] = useState(null);

  useEffect(() => {
    async function fetchGlobalContent() {
      try {
        const { data, error } = await supabase
          .from('page_content')
          .select('content')
          .eq('page_id', 'global')
          .single();

        if (error) {
          console.warn('Could not fetch global content, using defaults.', error.message);
        } else if (data && data.content) {
          setGlobalContent(data.content);
        }
      } catch (err) {
        console.error('Error fetching global content:', err);
      }
    }
    fetchGlobalContent();
  }, []);

  const handleSaveSuccess = (newContent) => {
    setGlobalContent(newContent);
  };

  // Merge the globalContent with defaultContent to ensure any new keys are exposed to the editor
  const mergedGlobalContent = {
    ...defaultContent.global,
    ...(globalContent || {})
  };

  return (
    <AdminProvider>
      <EditorProvider>
        <GlobalEditorRegister content={mergedGlobalContent} onSave={handleSaveSuccess} />
        <Router>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen bg-sand-50 dark:bg-brand-slate font-sans text-[#333] dark:text-[#fff]">
          <OnSiteEditor />
          <Navbar content={globalContent} />
        <main className="flex-grow pt-20">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/coaching" element={<Coaching />} />
              <Route path="/workshops" element={<Workshops />} />
              <Route path="/parenting-strategies" element={<ParentingStrategies />} />
              <Route path="/affirmations" element={<Affirmations />} />
              <Route path="/lies-price-advice" element={<LiesPriceAdvice />} />
              <Route path="/self-care" element={<SelfCare />} />
              <Route path="/workbook" element={<Workbook />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AnimatePresence>
          </main>
            <Footer content={globalContent} />
          </div>
        </Router>
      </EditorProvider>
    </AdminProvider>
  );
}

export default App;